import {toast} from 'react-toastify'
import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const Seo = {
  get: (callback: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/settings/seo`, callback, setIsLoading)
  },

  put: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/settings/seo`, data, callback, setIsLoading)
  },
}
export default Seo
